import { render, staticRenderFns } from "./Unavailability.vue?vue&type=template&id=6c4ea548"
import script from "./Unavailability.vue?vue&type=script&lang=ts"
export * from "./Unavailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports